import React from 'react';
import loadable from '@loadable/component';

const JoybirdMasonryComponentNew = loadable(() =>
  import('./JoybirdMasonryComponentNew')
);

const JoybirdMasonry = ({ photoCardsList, isSidebarOpen = false }) => (
  <JoybirdMasonryComponentNew
    photoCardsList={photoCardsList}
    isSidebarOpen={isSidebarOpen}
  />
);

export default JoybirdMasonry;
